export enum InvoiceStatusCodes {
    Draft = 'DRAF',
    Discarded = 'DISC',
    WaitingApproval = 'WFAP',
    Rejected = 'REJC',
    RejectedByPoint = 'REPO',
    Issued = 'ISSD',
    Cancelled = 'CANC',
    Closed = 'CLOS'
}

export type InvoicetStatusCodesStatusCode = InvoiceStatusCodes;
